import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { useAuth } from '../context/AuthContext';
import './LandingPage.css';

const LandingPage = () => {
  const { t } = useLanguage();
  const { isAuthenticated } = useAuth();
  const [message, setMessage] = useState('');
  const [isTyping, setIsTyping] = useState(false);
  const location = useLocation();
  // ลบ state, useEffect, และการใช้ landingContent ใน hero section
  // ใส่ข้อความ hardcode เดิมกลับไป

  useEffect(() => {
    if (location.hash) {
      const el = document.querySelector(location.hash);
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    }
  }, [location]);

  const handleSendMessage = (e) => {
    e.preventDefault();
    if (message.trim()) {
      setIsTyping(true);
      // Simulate AI response
      setTimeout(() => {
        setIsTyping(false);
        setMessage('');
      }, 2000);
    }
  };

  const features = [
    {
      icon: '✈️',
      title: 'AI-Powered Route Optimization',
      description: 'Our smart platform crunches millions of options to find the fastest connections and best-value fares.'
    },
    {
      icon: '📋',
      title: 'All-in-One Travel Organizer',
      description: 'Pull every flight, hotel, tour, and dinner reservation into one interactive timeline.'
    },
    {
      icon: '👥',
      title: 'Collaborative Planning',
      description: 'Share your itinerary and let everyone vote on activities. Perfect for families and groups.'
    }
  ];

  const testimonials = [
    {
      text: "An absolutely amazing trip planner, so much incredible information available, produces fantastic itineraries. Great videos, reels etc.",
      author: "Sarah M.",
      rating: 5
    },
    {
      text: "Mellow is a fascinating, inspirational ai trip planning tool that made a super customized itinerary for my Japan trip.",
      author: "Michael K.",
      rating: 5
    },
    {
      text: "Fav new app. Literally planned a whole trip to Thailand for me. She's really funny and smart and I love the bucketlists!!",
      author: "Emma L.",
      rating: 5
    }
  ];

  const topTrips = [
    {
      title: "Road Trip Through the South of Spain",
      image: "https://images.unsplash.com/photo-1539037116277-4db20889f2d4?w=400&h=300&fit=crop",
      duration: "10 Days"
    },
    {
      title: "10 Days in Vietnam: Culture & Adventure",
      image: "https://images.unsplash.com/photo-1528127269322-539801943592?w=400&h=300&fit=crop",
      duration: "10 Days"
    },
    {
      title: "Romantic Getaway in the Amalfi Coast",
      image: "https://images.unsplash.com/photo-1516483638261-f4dbaf036963?w=400&h=300&fit=crop",
      duration: "7 Days"
    },
    {
      title: "Ultimate Summer Escape to Croatia",
      image: "https://images.unsplash.com/photo-1559827260-dc66d52bef19?w=400&h=300&fit=crop",
      duration: "12 Days"
    }
  ];

  const reviews = [
    {
      avatar: process.env.PUBLIC_URL + '/2.png',
      name: "คุณบอย",
      rating: 5,
      text: "บริการดีมาก วางแผนเที่ยวญี่ปุ่นได้ง่ายสุด ๆ!"
    },
    {
      avatar: process.env.PUBLIC_URL + '/2.png',
      name: "คุณพิณ",
      rating: 4.5,
      text: "แนะนำเลยค่ะ ประทับใจมาก ๆ"
    },
    {
      avatar: process.env.PUBLIC_URL + '/2.png',
      name: "คุณเอ",
      rating: 5,
      text: "ใช้งานง่ายและสะดวกมาก ๆ ครับ"
    }
  ];
  const [current, setCurrent] = useState(0);
  const showCount = typeof window !== 'undefined' && window.innerWidth < 700 ? 1 : 2;
  const maxIndex = reviews.length - showCount;
  const goLeft = () => setCurrent(current > 0 ? current - 1 : maxIndex);
  const goRight = () => setCurrent(current < maxIndex ? current + 1 : 0);

  // ฟังก์ชันสำหรับกำหนด URL ตามสถานะการล็อคอิน
  const getTripPlanningUrl = () => {
    return isAuthenticated ? '/plan-trip' : '/login';
  };

  // ฟังก์ชันสำหรับกำหนด URL ของแพ็กเกจ
  const getPackageUrl = () => {
    return isAuthenticated ? '/dashboard' : '/login';
  };

  return (
    <div className="landing-page">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content hero-content--custom">
          <div className="hero-text hero-text--custom">
            <h1 className="hero-title hero-title--custom">
              วางแผนเที่ยวญี่ปุ่นง่ายๆ<br />
              <span className="highlight highlight--custom">แบบมืออาชีพกับ MELLOW</span>
            </h1>
            <p className="hero-subtitle hero-subtitle--custom">
              จะเที่ยวญี่ปุ่นทั้งที...ไม่อยากปวดหัวเรื่องเส้นทาง ที่พัก หรือเวลาเดินทาง?<br />
              Mellow Plan ช่วยออกแบบทริปให้คุณแบบละเอียด พร้อมเที่ยวได้จริง ไม่ต้องวางแผนเองเลย!
            </p>
            <form className="hero-search-form">
              <input
                type="text"
                className="hero-search-input"
                placeholder="ลองพิมพ์บอกเรา... เช่น 'สร้างแผนเที่ยวฟุกุโอกะ 4 วัน เน้นธรรมชาติและคาเฟ่'"
              />
            </form>
            <div className="hero-suggest-buttons">
              <button className="hero-suggest-btn">ทริปครอบครัวโตเกียว 5 วัน</button>
              <button className="hero-suggest-btn">เที่ยวโอซาก้าสะดวกกัน</button>
              <button className="hero-suggest-btn">ขับรถเที่ยวฮอกไกโด 7 วัน</button>
            </div>
            <div className="hero-action-row">
              <Link to={getTripPlanningUrl()} className="hero-main-btn">✈️ สร้างแผนเที่ยวเลย</Link>
              <a href="#" className="hero-link">Mellow คืออะไร?</a>
            </div>
          </div>
          <div className="hero-image hero-image--custom">
            <img src={process.env.PUBLIC_URL + '/chilljapan-3.png'} alt="Mellow Hero" className="hero-img-main" />
          </div>
        </div>
      </section>
      {/* Fuji Fullwidth Section */}
      <section className="fuji-fullwidth-section">
        <img src={process.env.PUBLIC_URL + '/fuji.png'} alt="Fuji" className="fuji-fullwidth-img" />
        <div className="fuji-img-text">
          <br />
          วางแผนเที่ยวญี่ปุ่นง่ายๆ<br />
          แบบมืออาชีพกับ <span className="fuji-img-highlight">MELLOW</span>
        </div>
      </section>
      {/* ส่วนบริการของเรา */}
      <section className="our-services-section">
        <div className="our-services-container">
          <div className="our-services-header">
            <div className="our-services-title-box">
              <h2 className="our-services-title">บริการของเรา</h2>
              <div className="our-services-sub">MELLOW SERVICE</div>
            </div>
            <p className="our-services-desc">
              จะเที่ยวญี่ปุ่นทั้งที...ไม่อยากปวดหัวเรื่องเส้นทาง ที่พัก หรือเวลาเดินทาง?<br />
              Mellow Plan ช่วยออกแบบทริปให้คุณแบบละเอียด พร้อมเที่ยวได้จริง ไม่ต้องวางแผนเองเลย!
            </p>
          </div>
          
          <div className="features-grid features-grid--custom">
            <div className="feature-card feature-card--custom">
              <div className="feature-icon feature-icon--custom">✈️</div>
              <h3 className="feature-title--custom">เที่ยวได้เลย ไม่ต้องวางแผนเอง</h3>
              <p className="feature-desc--custom">
                แค่บอกว่าคุณอยากไปไหน Mellow Plan วางแผนให้ละเอียดจบครบทั้งเส้นทาง ที่พัก กิจกรรม ร้านอาหาร และจุดแวะเที่ยวที่น่าสนใจ ตั้งแต่ต้นจนจบ ไม่ต้องเสียเวลาทำเอง
              </p>
            </div>
            <div className="feature-card feature-card--custom">
              <div className="feature-icon feature-icon--custom">📍</div>
              <h3 className="feature-title--custom">มีเส้นทางเวลาเดินทางให้ทุกจุด</h3>
              <p className="feature-desc--custom">
                ทุกจุดที่แนะนำมีแผนเดินทางให้ครบ พร้อมลิงก์แผนที่ Google Maps กดตามได้เลย ไม่ต้องเดาเส้นทางเอง
              </p>
            </div>
            <div className="feature-card feature-card--custom">
              <div className="feature-icon feature-icon--custom">🧳</div>
              <h3 className="feature-title--custom">ปรับแผนให้เหมาะกับกลุ่มคุณ</h3>
              <p className="feature-desc--custom">
                เที่ยวกับครอบครัว เพื่อน หรือคู่รัก? ชอบชิลหรือชอบลุย? ระบุความต้องการแล้วรับแผนเที่ยวที่เหมาะกับคุณ
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Example Stories Section */}
      <section className="example-stories-section" id="trip-examples">
        <div className="example-stories-container">
          <h2 className="example-stories-title">เล่าให้เราฟัง - ว่าคุณอยากไปเที่ยวที่ไหน</h2>
          <div className="example-stories-desc">
            เพียงพิมพ์บอกรายละเอียดกับเรา เช่น ฉันอยากไปโตเกียว 3 วัน ไปโอซาก้า 3 วัน โดยเดินทางทั้งหมด 6 คน ผู้ใหญ่ 4 เด็ก 2<br />
            ฉันต้องการเที่ยวแบบสบายไม่เหนื่อยเกินไปและมีสถานที่ให้เด็กเที่ยวได้
          </div>
          <div className="example-stories-grid">
            <div className="example-story-card">
              <img src={process.env.PUBLIC_URL + '/japan2.png'} alt="story1" className="example-story-img" />
              <Link to={getTripPlanningUrl()} className="example-story-ask">Ask <span style={{fontSize: '1.1em'}}>✈️</span></Link>
              <div className="example-story-caption">
                <em>"We just got engaged and crave six days of pure zen - think autumn-coloured gardens, private hot-spring soaks and a hands-on sushi lesson this October"</em>
              </div>
            </div>
            <div className="example-story-card">
              <img src={process.env.PUBLIC_URL + '/tokyo.jpg'} alt="story2" className="example-story-img" />
              <Link to={getTripPlanningUrl()} className="example-story-ask">Ask <span style={{fontSize: '1.1em'}}>✈️</span></Link>
              <div className="example-story-caption">
                <em>"It’s my 30th with five besties, give us four sun-drenched days of turquoise swims, all pool parties and sunset boat cruises in July"</em>
              </div>
            </div>
            <div className="example-story-card">
              <img src={process.env.PUBLIC_URL + '/osaka.jpg'} alt="story3" className="example-story-img" />
              <Link to={getTripPlanningUrl()} className="example-story-ask">Ask <span style={{fontSize: '1.1em'}}>✈️</span></Link>
              <div className="example-story-caption">
                <em>"I have always dreamed of spotting the Big Five. Plan an eight-day road-trip next winter with whale watching, self-drive safaris and cosy budget lodges."</em>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Sample Itinerary Section */}
      <section className="sample-itinerary-section">
        <div className="sample-itinerary-container">
          <h2 className="sample-itinerary-title">ตัวอย่างแผนเที่ยว</h2>
          <div className="sample-itinerary-sub">MELLOW SERVICE</div>
          <div className="sample-itinerary-desc">
            จะเที่ยวญี่ปุ่นทั้งที...ไม่อยากปวดหัวเรื่องเส้นทาง ที่พัก หรือเวลาเดินทาง?<br />
            Mellow Plan ช่วยออกแบบทริปให้คุณแบบละเอียด พร้อมเที่ยวได้จริง ไม่ต้องวางแผนเองเลย!
          </div>
          <div className="sample-itinerary-list">
            {[
              {
                day: 1,
                title: 'ย่าน Ueno, เดินเล่น Ameyoko',
                image: process.env.PUBLIC_URL + '/tokyo.jpg',
                highlight: 'ไฮไลท์ประจำวัน',
                place: 'ย่าน Ueno',
                activity: 'เดินเล่น Ameyoko',
                details: [
                  { label: 'ที่พัก', value: 'APA Hotel Ueno Ekimae' },
                  { label: 'ค่าใช้จ่าย', value: '¥7,500' },
                  { label: 'การเดินทาง', value: 'Skyliner' }
                ],
                note: 'วันเดินทางเข้า : เช็คอินตามเวลาของแต่ละที่พักก่อนนะคะ',
              },
              {
                day: 2,
                title: 'Harry Potter Studio',
                image: process.env.PUBLIC_URL + '/osaka.jpg',
                highlight: 'ไฮไลท์ประจำวัน',
                place: 'โซนงานแฟน 1 วันเต็ม',
                details: [
                  { label: 'ที่พัก', value: 'โรงแรมแนะนำ' },
                  { label: 'ค่าใช้จ่าย', value: '¥9,000' },
                  { label: 'การเดินทาง', value: 'รถไฟสาย Ikebukuro' }
                ],
                note: 'ซื้อตั๋วล่วงหน้า (แนะนำอ่านคำแนะนำ Part 3)',
              }
            ].map((item, idx) => (
              <div className="sample-itinerary-card" key={idx}>
                <div className="sample-itinerary-day">
                  <div className="sample-itinerary-day-circle">DAY<br />{item.day}</div>
                </div>
                <div className="sample-itinerary-content">
                  <img src={item.image} alt={item.title} className="sample-itinerary-img" />
                  <div className="sample-itinerary-info">
                    <div className="sample-itinerary-title-row">
                      <span className="sample-itinerary-title-main">{item.title}</span>
                    </div>
                    <div className="sample-itinerary-highlight">⭐ {item.highlight}</div>
                    <div className="sample-itinerary-place">{item.place}</div>
                    <div className="sample-itinerary-activity">{item.activity}</div>
                    <div className="sample-itinerary-details">
                      {item.details.map((d, i) => (
                        <div key={i} className="sample-itinerary-detail-row">
                          <span className="sample-itinerary-detail-label">{d.label}:</span> <span className="sample-itinerary-detail-value">{d.value}</span>
                        </div>
                      ))}
                    </div>
                    <div className="sample-itinerary-note">หมายเหตุ: {item.note}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div style={{ textAlign: 'center', marginTop: '24px' }}>
            <Link to={getTripPlanningUrl()} className="sample-itinerary-btn">ดูแผนทั้งหมด</Link>
          </div>
        </div>
      </section>
      {/* Customer Reviews Section (Carousel) */}
      <section className="customer-reviews-section" id="customer-reviews">
        <div className="customer-reviews-container">
          <h2 className="customer-reviews-title">
            รีวิวจากลูกค้า<br />
            <span className="customer-reviews-title-en">MELLOW REVIEW</span><br />
          </h2>
          <div className="customer-reviews-desc">เสียงจริงจากผู้ใช้งานที่วางแผนเที่ยวกับ Mellow</div>
          <div className="customer-reviews-carousel">
            <div className="customer-reviews-grid carousel-grid">
              {reviews.map((item, idx) => (
                <div className="customer-review-card" key={idx}>
                  <img src={item.avatar} alt={item.name} className="customer-review-avatar" />
                  <div className="customer-review-name">{item.name}</div>
                  <div className="customer-review-rating">
                    {Array.from({length: Math.floor(item.rating)}).map((_, i) => <span key={i}>⭐</span>)}
                    {item.rating % 1 !== 0 && <span>⭐️</span>}
                  </div>
                  <div className="customer-review-text">“{item.text}”</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      {/* Package Price Section */}
      <section className="package-section" id="package-pricing">
        <div className="package-container">
          <div className="package-mascot-col">
            <img
              src="/mascot.png"
              alt="Mellow Mascot"
              className="package-mascot-img"
            />
          </div>
          <div className="package-content-col">
            <h2 className="package-title">เลือกแพ็กเกจที่เหมาะกับคุณ</h2>
            <div className="package-subtitle">MELLOW PRICE</div>
            <div className="package-desc">
              ไม่ว่าจะอยากให้เราช่วยแค่บางส่วน หรือวางแผนครบจบทุกวัน Mellow Plan มีแพ็กเกจที่ใช่สำหรับคุณ
            </div>
            <div className="package-cards-row">
              <div className="package-card">
                <div className="package-card-title">Package 7 Days</div>
                <div className="package-card-price"><span className="package-card-price-main">990</span> <span style={{fontSize: '1rem', color: '#222', fontWeight: 'normal'}}>/บาท</span></div>
                <div className="package-card-desc">แพ็กเกจสำหรับนักเดินทางที่ต้องการความสะดวกสบายสูงสุด</div>
                <ul className="package-card-list">
                  <li>วางแผนการเดินทาง 7 วัน</li>
                  <li>ปรับแผนฟรี 3 ครั้ง</li>
                  <li>แนะนำร้านอาหารและที่เที่ยว</li>
                  <li>ไฟล์แผนการเดินทางแบบ PDF</li>
                  <li>ซัพพอร์ตผ่านแชท</li>
                </ul>
                <Link to={getPackageUrl()} className="package-card-btn">เลือกแพ็กเกจนี้</Link>
              </div>
              <div className="package-card">
                <div className="package-card-badge">คุ้มที่สุด</div>
                <div className="package-card-title">Package 30 Days</div>
                <div className="package-card-price"><span className="package-card-price-main">1,490</span> <span style={{fontSize: '1rem', color: '#222', fontWeight: 'normal'}}>/บาท</span></div>
                <div className="package-card-desc">แพ็กเกจสำหรับนักเดินทางที่ต้องการความสะดวกสบายสูงสุด</div>
                <ul className="package-card-list">
                  <li>วางแผนการเดินทางสูงสุด 30 วัน</li>
                  <li>ปรับแผนได้ไม่จำกัด</li>
                  <li>บริการจองร้านอาหาร/กิจกรรม</li>
                  <li>ไฟล์ PDF และ Google Maps</li>
                  <li>ซัพพอร์ตตลอดทริพระหว่างเดินทาง</li>
                  <li>ส่วนลดสำหรับบริการเช่า</li>
                </ul>
                <Link to={getPackageUrl()} className="package-card-btn">เลือกแพ็กเกจนี้</Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* 4 Steps Section */}
      <section className="steps-section" id="booking-steps">
        <div className="steps-container">
          <h2 className="steps-title">แค่ 4 ขั้นตอน...ก็เที่ยวญี่ปุ่นได้แบบไม่ต้องแพลนเอง</h2>
          <div className="steps-subtitle">MELLOW 4 STEP</div>
          <div className="steps-desc">เริ่มง่าย ๆ ไม่ต้องมีประสบการณ์ แค่บอกเราว่าชอบเที่ยวแบบไหน ที่เหลือ Mellow Plan จัดให้!</div>
          <div className="steps-timeline">
            <div className="step-card">
              <div className="step-icon">💬</div>
              <div className="step-content">
                <div className="step-title">1. ทักหาเรา</div>
                <div className="step-desc">ทัก LINE มาคุยกับทีม Mellow Plan บอกเป้าหมาย งบประมาณ และสไตล์ที่อยากเที่ยว (กิน/ช้อป/ครอบครัว/ชิลๆ)</div>
              </div>
            </div>
            <div className="step-card">
              <div className="step-icon">📦</div>
              <div className="step-content">
                <div className="step-title">2. รับคำแนะนำ + เลือกแพ็กเกจ</div>
                <div className="step-desc">เราจะเสนอแพ็กเกจที่เหมาะสมที่สุดสำหรับคุณ เมื่อเลือกได้แล้วสามารถโอนชำระเพื่อเริ่มวางแผนได้ทันที</div>
              </div>
            </div>
            <div className="step-card">
              <div className="step-icon">👩‍💻</div>
              <div className="step-content">
                <div className="step-title">3. ทีมจัดทำแผนส่วนตัว</div>
                <div className="step-desc">เรามีออกแบบแผนเที่ยวเฉพาะสำหรับคุณ แนะนำที่พัก ร้านอาหาร และการเดินทางที่พร้อมใช้งานได้จริง</div>
              </div>
            </div>
            <div className="step-card">
              <div className="step-icon">🗺️</div>
              <div className="step-content">
                <div className="step-title">4. รับแผนเที่ยว พร้อมลุย!</div>
                <div className="step-desc">คุณจะได้รับแผนเที่ยวในรูปแบบ PDF และ Google Maps พร้อมเที่ยวได้เลย ไม่ต้องปวดหัววางแผนเองอีกต่อไป!</div>
              </div>
            </div>
          </div>
          <Link to={getTripPlanningUrl()} className="steps-btn">เริ่มต้นวางแผนเลย</Link>
        </div>
      </section>
      {/* ส่วนบริการรถยนต์ */}
      <section className="car-service-section">
        <div className="car-service-container">
          <div className="car-service-header">
            <h2 className="car-service-title">อยากให้ทริปยิ่งสบาย? ลองใช้ Mellow Car</h2>
            <div className="car-service-brand">Mellow Car</div>
            <p className="car-service-description">
              บริการรถพร้อมคนขับในญี่ปุ่น สำหรับคนที่อยากเที่ยวแบบไม่ต้องเหนื่อยขับรถเองหรือเดินทางรถไฟ หรือมีสัมภาระเยอะ
            </p>
          </div>

          <div className="car-service-card">
            {/* ส่วน AI ช่วยเลือก */}
            <div className="ai-assistance-section">
              <div className="ai-header">
                <div className="ai-mascot">🐱</div>
                <h3 className="ai-title">ไม่แน่ใจ? ให้ AI ช่วยเลือก</h3>
              </div>
              <p className="ai-description">
                แค่บอกลักษณะทริปที่วางแผนอยู่ตอนนี้ AI จะแนะนำรถที่เหมาะให้เลย!
              </p>
              <div className="ai-input-section">
                <input 
                  type="text" 
                  className="ai-input" 
                  placeholder="เช่น ไปกับครอบครัว 5 คน มีเด็กเล็ก, อยากได้รถใหญ่ๆ"
                />
                <button className="ai-recommend-btn">ให้ AI แนะนำ</button>
              </div>
            </div>

            {/* ส่วนค้นหารถ */}
            <div className="car-search-section">
              <div className="search-form">
                <div className="search-input-group">
                  <input 
                    type="text" 
                    className="search-input" 
                    placeholder="ท่าอากาศยานนานาชาติคันไซ (KIX)"
                  />
                  <span className="dropdown-arrow">▼</span>
                </div>
                <div className="search-input-group">
                  <input 
                    type="text" 
                    className="search-input" 
                    placeholder="วันและเวลารับรถ"
                  />
                </div>
                <div className="search-input-group">
                  <input 
                    type="text" 
                    className="search-input" 
                    placeholder="วันและเวลาคืนรถ"
                  />
                </div>
                <button className="search-btn">ค้นหา</button>
              </div>
              <button className="road-trip-btn">
                ฮิต! เส้น Road Trip จากท่าอากาศยานคันไซ (KIX)
              </button>
            </div>
          </div>

          {/* ส่วนรายการรถ */}
          <div className="car-listings-section">
            <div className="car-listings-container">
              <div className="car-card">
                <div className="car-image">
                  <img src={process.env.PUBLIC_URL + '/ativ-night.png'} alt="Toyota Yaris" className="car-img" />
                </div>
                <div className="car-info">
                  <h4 className="car-model">Toyota Yaris</h4>
                  <div className="car-type">Compact Car</div>
                  <div className="car-specs">
                    <span className="spec-item">👥 5</span>
                    <span className="spec-item">🧳 2</span>
                    <span className="spec-item">⚙️ ออโต้</span>
                  </div>
                  <div className="car-price">990 ฿ /วัน</div>
                  <button className="book-btn">จองเลย</button>
                </div>
              </div>

              <div className="car-card">
                <div className="car-image">
                  <img src={process.env.PUBLIC_URL + '/ativ-night.png'} alt="Toyota Ativ" className="car-img" />
                </div>
                <div className="car-info">
                  <h4 className="car-model">Toyota Ativ</h4>
                  <div className="car-type">Compact Car</div>
                  <div className="car-specs">
                    <span className="spec-item">👥 5</span>
                    <span className="spec-item">🧳 2</span>
                    <span className="spec-item">⚙️ ออโต้</span>
                  </div>
                  <div className="car-price">1,050 ฿ /วัน</div>
                  <button className="book-btn">จองเลย</button>
                </div>
              </div>

              <div className="car-card">
                <div className="car-image">
                  <img src={process.env.PUBLIC_URL + '/ativ-night.png'} alt="Toyota Veloz" className="car-img" />
                </div>
                <div className="car-info">
                  <h4 className="car-model">Toyota Veloz</h4>
                  <div className="car-type">SUV</div>
                  <div className="car-specs">
                    <span className="spec-item">👥 7</span>
                    <span className="spec-item">🧳 3</span>
                    <span className="spec-item">⚙️ ออโต้</span>
                  </div>
                  <div className="car-price">1,490 ฿ /วัน</div>
                  <button className="book-btn">จองเลย</button>
                </div>
              </div>

              <div className="car-card">
                <div className="car-image">
                  <img src={process.env.PUBLIC_URL + '/ativ-night.png'} alt="Toyota Yaris" className="car-img" />
                </div>
                <div className="car-info">
                  <h4 className="car-model">Toyota Yaris</h4>
                  <div className="car-type">Compact Car</div>
                  <div className="car-specs">
                    <span className="spec-item">👥 5</span>
                    <span className="spec-item">🧳 2</span>
                    <span className="spec-item">⚙️ ออโต้</span>
                  </div>
                  <div className="car-price">990 ฿ /วัน</div>
                  <button className="book-btn">จองเลย</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* 24hr Support Section */}
      <section className="support24-section" id="contact-us">
        <div className="support24-container">
          <h2 className="support24-title">อุ่นใจตลอด 24 ชั่วโมง</h2>
          <div className="support24-desc">
            <span className="support24-icon">🛟</span>
            ทีมงาน Mellow พร้อมดูแล ให้คำปรึกษา และช่วยเหลือคุณตลอดการเดินทาง<br />
            ไม่ว่าคุณจะเจอปัญหาอะไร เราพร้อมช่วยเหลือ 24/7
          </div>
          <div className="support24-mascot">
            <img src="/mascot.png" alt="Mellow Mascot" />
          </div>
          <div className="support24-contact">
            <span className="support24-contact-icon">📞</span> ติดต่อทีมงานได้ทุกเวลา ผ่าน LINE หรือโทรศัพท์
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <h2>พร้อมออกเดินทางสู่ประสบการณ์ใหม่หรือยัง?</h2>
          <p>เข้าร่วมกับนักเดินทางนับพันที่ไว้วางใจให้ Mellow วางแผนทริปให้คุณ</p>
          <Link to={getTripPlanningUrl()} className="cta-button">
            เริ่มวางแผนเลย
          </Link>
        </div>
      </section>
      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-section">
              <h4>เกี่ยวกับเรา</h4>
              <ul>
                <li><a href="#">เกี่ยวกับ Mellow</a></li>
                <li><Link to="/contact">ติดต่อเรา</Link></li>
              </ul>
            </div>
            <div className="footer-section">
              <h4>บริการ</h4>
              <ul>
                <li><a href="#">จองที่พัก</a></li>
                <li><a href="#">Roam Around</a></li>
                <li><a href="#">พันธมิตร</a></li>
              </ul>
            </div>
            <div className="footer-section">
              <h4>วางแผน</h4>
              <ul>
                <li><a href="#">ทริปคู่รัก</a></li>
                <li><a href="#">ทริปครอบครัว</a></li>
              </ul>
            </div>
            <div className="footer-section">
              <h4>กฎหมาย</h4>
              <ul>
                <li><a href="#">ความเป็นส่วนตัว</a></li>
                <li><a href="#">เงื่อนไข</a></li>
              </ul>
            </div>
          </div>
          <div className="footer-bottom">
            <p>© 2025 All right reserved by Mellow AI GmbH</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage; 